import { render } from "./HeaderComponent.vue?vue&type=template&id=376740d8&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=376740d8&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376740d8"]])

export default __exports__